












































import { defineComponent, ref } from "@vue/composition-api";
import Page from "@/components/layout/page.vue";
import PageHeader from "@/components/navigation/page-header.vue";
import DataTable from "@/components/data/data-table.vue";
import { Floor, Zone } from "@/swagger/models";
import { DataTableConfig } from "@/components/data/data-table";
import { useRouter } from "@/router/router";
import { zoneService } from "@/services/zone";

export default defineComponent({
    name: "zones-table",
    props: {
        floorId: {
            type: Number,
        },
        officeId: {
            type: Number,
        },
        withFloor: {
            type: Boolean,
            default: false,
        },
        hideCreate: {
            type: Boolean,
            default: false,
        },
    },
    components: { Page, PageHeader, DataTable },
    setup(props, context) {
        const { router, route } = useRouter(context);

        const zones = ref<Zone[]>([]);
        const loading = ref(false);

        (async () => {
            loading.value = true;
            zones.value = await zoneService.find({
                params: {
                    floor: props.floorId,
                    office: props.officeId,
                },
            });
            loading.value = false;
        })();

        const tableConfig: DataTableConfig<Zone> = {
            clickItemCallback: (item: Zone) => {
                router.push({
                    name: "zone",
                    params: {
                        floorId: item.floor ? (item.floor as Floor).id.toString() : route.value.params.floorId,
                        zoneId: item.id.toString(),
                    },
                });
            },
            items: zones,
            fields: [
                {
                    label: "ID",
                    field: "id",
                    compact: true,
                },
                {
                    label: "Name",
                    field: "name",
                },

                // Woo-hoo javascript
                ...(props.withFloor
                    ? [
                          {
                              label: "Floor",
                              field: "floor",
                          },
                      ]
                    : []),
                {
                    label: "Created",
                    field: "createdAt",
                    compact: true,
                },
                {
                    label: "Updated",
                    field: "updatedAt",
                    compact: true,
                },
            ],
        };

        return { tableConfig, loading };
    },
});
